<template>
    <div class="sidebar-wrapper visible">
            <Legend :content="content"/>
            <div v-if="!legendToggled" id="story-sidebar" ref="div" class="sidebar-handler">
                <Storyhandler :content="content"/>
            </div>
            <div v-if="!legendToggled" ref="div" class="sidebar" @scroll="this.getScrollY">
                    <Introduction :title="introduction.title" :subtitle="introduction.subtitle" :authors="authors"/>
                    <div class="content-wrapper">
                        <div class="paragraph-wrapper">
                            <Paragraph class="paragraph" :data="{ highlighted: p['highlighted'], snippetId: p['id'], pId: p['pId'], divideHeight: p['divideHeight'], refId: p['refId'], snippetText: p['snippetText'] }" :key="p['uniqueId']" :id="'id-' + p['pId']" v-for="p in paragraphsArr" :content="p"/>
                        </div>
                    </div>
                    <div style="height: 800px"><!-- Placeholder --></div>
            </div>

            <div v-if="!legendToggled" class="indicator-active-left">

                <svg width="6px" height="9px" viewBox="0 0 6 9" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="Artboard" transform="translate(-1308.000000, -303.000000)" stroke="#000000" stroke-width="2">
                            <polyline id="Path-2" transform="translate(1311.000000, 307.500000) rotate(-90.000000) translate(-1311.000000, -307.500000) " points="1308 306 1311.06334 309 1314 306"></polyline>
                        </g>
                    </g>
                </svg>

            </div>

            <div class="signifier-scroll">

                
                <svg width="14px" height="15px" viewBox="0 0 14 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="Artboard" transform="translate(-1410.000000, -912.000000)" stroke="#000000" stroke-width="2.4">
                            <g id="Group-2" transform="translate(1411.000000, 913.000000)">
                                <polyline id="Path-2" points="0 6 6.12667628 12 12 6"></polyline>
                                <polyline id="Path-2-Copy" points="0 0 6.12667628 6 12 0"></polyline>
                            </g>
                        </g>
                    </g>
                </svg>
                <span>Scroll to continue</span>
            </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    import { 
        select as d3Select,
    } from 'd3';

    import SidebarToggle from './SidebarToggle.vue';
    import Introduction from './Introduction.vue';
    import Paragraph from './Paragraph.vue';
    import Storyhandler from './Storyhandler.vue';
    import Indicators from './Indicators.vue';
    import Legend from './Legend.vue'

    export default {
        name: "Sidebar",    
        props: ['divid', 'pos', 'content', 'storyActive', 'paragraphActive'],
        components: {
            SidebarToggle,
            Introduction,
            Paragraph,
            Storyhandler,
            Legend
        },
        data() {
            return {
                container:  null,
                time: null,
                resetTimerTime: 750,
                highlighted: null,
                timeProgress: null
            }
        },
        computed: {
            ...mapState(['sidebarVisible', 'data', 'legendToggled']),
            paragraphsArr() {
                return this.content.stories[this.storyActive].paragraphs;
            },
            introduction() {
                return this.content.stories[this.storyActive].introduction;
            },
            authors() {
                return this.content.stories[this.storyActive].authors;
            },
            dataAvailable() {
                return this.data != null;
            },
        },
        watch: {
            sidebarVisible() {
                this.checkSidebarVisible();
            },
            sidebarHandlerToggled() {
                console.log(this.sidebarHandlerToggled, this.sidebarStoryToggled)
            },
            legendToggled() {
                if (this.legendToggled) {
                    d3Select('.sidebar-wrapper').classed('scrolling', true)
                }

                if (!this.legendToggled) {
                    d3Select('.sidebar-wrapper').classed('scrolling', false)
                }
            }
        },
        methods: {
            dispatchSetParagraphActive(elm) {
                const id = elm.id.slice(3);
                this.$store.dispatch("SET_PARAGRAPH_ACTIVE", id);
            },
            dispatchSetVisRendered(val) {
                this.$store.dispatch("SET_VIS_RENDERED", val);
            },
            init(container) {
                this.layout(container);
            },
            layout(container) {
                container.classed(this.pos, true)
            },
            resetTimer(elm) {
                clearTimeout(this.time);
                this.time = setTimeout(() => {
                    this.dispatchSetParagraphActive(elm)
                }, this.resetTimerTime)
            },
            resetTimerProgress(elm) {
                clearTimeout(this.timeProgress);
                this.timeProgress = setTimeout(() => {
                    document.querySelector('.progress').classList.remove('progressFurther');
                }, 1500)
            },
            getScrollY() {
                this.paragraphsArr.forEach(p => {
                    if (p.id  != undefined) {
                        const paragraph = d3Select(`div#id-${p.id}`).node();
                        this.detectScrollTop(paragraph);
                    }
                })
            },
            checkSidebarVisible() {
                if (this.sidebarVisible == this.pos) {
                    this.container.classed('active', true);
                    d3Select('.sidebar-toggle').classed('active', true);
                } else if (this.sidebarVisible == 'none') {
                    this.container.classed('active', false);
                    d3Select('.sidebar-toggle').classed('active', false);
                }
            },
            detectScrollTop(elm) {
                const offsetTop = elm.getBoundingClientRect().top;

                if (offsetTop < 300 && offsetTop > 300 - elm.getBoundingClientRect().height) {

                    if (d3Select(elm).node().childNodes[0].childNodes[1].childNodes[0] != undefined) {
                        if (this.highlighted != d3Select(elm).attr('id') && d3Select(elm).node().childNodes[0].childNodes[1].childNodes[0].classList != undefined) {
                            document.querySelector('.progress').classList.add('progressFurther');
                            this.highlighted = d3Select(elm).attr('id');
    
                        } else if (d3Select(elm).node().classList.contains('progressFurther')) {
                            document.querySelector('.progress').classList.remove('progressFurther');
                        }
                    }


                    d3Select(elm).classed('highlighted', true);
                    console.log(d3Select(elm).attr('id'))
                    this.resetTimer(elm);
                    this.resetTimerProgress(document.querySelector('.progress'));
                } else {
                    d3Select(elm).classed('highlighted', false);
                }
            },
            resizing() {
                let width = window.innerWidth;
                const wrapperIntro = document.querySelector('.wrapper-intro');
                const wrapper = document.querySelector('.sidebar-wrapper');
                const indicator = document.querySelector('.indicator-active-left');
                const nav = document.querySelector('.Nav');                

                if (Number(width) < 321) {
                    let newMargin = (width - 295) / 2;
                    wrapper.setAttribute('style', `margin-left: ${newMargin - 1}px`);
                    if (wrapperIntro != null) {
                        wrapperIntro.setAttribute('style', `margin-left: ${newMargin - 1}px`);
                    }
                    nav.setAttribute('style', `left: ${newMargin - 1}px; display: flex;`);
                    indicator.setAttribute('style', `left: ${newMargin + 3}px;`);
                } else if (Number(width) < 381) {
                    let newMargin = (width - 320) / 2;
                    wrapper.setAttribute('style', `margin-left: ${newMargin}px`);
                    if (wrapperIntro != null) {
                        wrapperIntro.setAttribute('style', `margin-left: ${newMargin}px`);
                    }
                    nav.setAttribute('style', `left: ${newMargin - 10}px; display: flex;`);
                    indicator.setAttribute('style', `left: ${newMargin + 5}px;`);
                } else if (Number(width) < 768) {
                    let newMargin = (width - 320) / 2;
                    nav.setAttribute('style', `left: ${newMargin - 10}px; display: flex;`);
                    indicator.setAttribute('style', `left: ${newMargin + 5}px;`);
                    wrapper.setAttribute('style', `margin-left: ${newMargin}px`);
                    if (wrapperIntro != null) {
                        wrapperIntro.setAttribute('style', `margin-left: ${newMargin}px`);
                    }
                } else {
                    nav.setAttribute('style', `left: ${0}px; display: flex;`);
                    indicator.setAttribute('style', `right: 315px;`);
                    wrapper.setAttribute('style', `margin-left: ${0}px`);
                    // wrapperIntro.setAttribute('style', `margin-left: ${0}px`);

                    // Keep Intro Centered
                    let newMargin = (width - 520) / 2;
                    if (wrapperIntro != null) {
                        wrapperIntro.setAttribute('style', `margin-left: ${newMargin}px`);
                    }
                }
            }
        },
        mounted() {
            this.container = d3Select(this.$refs.div)
                .attr('id', this.divid)

            this.init(this.container);
            this.checkSidebarVisible();
            this.resizing();

            window.addEventListener('resize', this.resizing);
        }
    }
</script>

<style lang="scss">
    @import '../assets/style/main.scss';

    .indicator-active-left {
        position: fixed;
        top: 300px;
        right: 317px;
        width: 12px;
        font-size: 12px;
    }

    .nav-mobile {
        position: absolute;
        width: 200px;
        height: 100px;
        bottom: 0;
    }

    .gradient-bottom {
        background-image: -webkit-linear-gradient(top, rgba(255,255,255,0.001) 0%, #fff 5%, #fff 100%);
        z-index: 10000;
        height: 100px;
        position: absolute;
    }

    .signifier-scroll {
        z-index: 100;
        position: absolute;
        bottom: 20px;
        left: 90px;

        @media screen and (max-width: 600px) {
            display: none;
        }

        span {
            margin-left: 10px;
            font-weight: 600;
            position: absolute;
            width: 220px;
            font-size: 13px;
        }
    }

    .sidebar-handler {
        border-radius: 8px 8px 0 0;
        height: 150px;
        overflow: auto;
        background: white;
        -ms-overflow-style: none;

        border-bottom: 1px solid #dfdfdf;
        transition: all $time-m ease-in-out;
    }

    .sidebar {
        overflow: scroll;
        height: 100%;
        margin-left: 15px;
        position: absolute;
        background: white;
        color: $color-primary;
        border: none;
        transition: all $time-m ease-in-out;

        // @media screen and (max-width: 380px) {
        //     width: 280px;
        // }

        .content-wrapper {
            min-width: 280px;

            // @media screen and (max-width: 380px) {
            //     width: 240px;
            //     min-width: 240px;
            // }
        }

        .scrolling {
            overflow: scroll;
        }

        &-wrapper {
            width: auto;
            margin: 10px;
            border-radius: 8px;
            overflow: hidden;
            min-width: 320px;
            margin-bottom: 10px;
            -ms-overflow-style: none;

            background: white;
            box-shadow: #f7f7f7 4px 4px 60px;
            border: 1px solid #dfdfdf;
            transition: all $time-m ease-in-out;
            position: relative;
            right: 0px;
            display: none;
            z-index: 3;

            @media screen and (min-width: 1081px) {
                position: relative;
            }

            @media screen and (max-width: 768px) {
                margin-bottom: 73px;
            }

            @media screen and (max-width: 320px) {
                min-width: 295px;
                margin-top: 9px;
            }

            // @media screen and (max-width: 380px) {
            //     width: 280px;
            //     min-width: 280px;
            // }

            &.visible {
                display: block !important;
            }

        }

        .highlighted {
            opacity: 1;
            transition: opacity $time-m ease-in-out;
        }
    }
    
</style>


